import React, { useMemo } from 'react';
import { Box, BoxExtendedProps, Text } from '@common-fe/common-fe';

import { IAccountStatusDtoStatusEnum } from '@/types';
interface Props extends BoxExtendedProps {
  status: IAccountStatusDtoStatusEnum;
  isWithIndicator?: boolean;
}
const EnrollmentsAccountHistoryStatus: React.FC<Props> = ({ isWithIndicator, status, ...rest }) => {
  const color = useMemo(() => {
    if (status === IAccountStatusDtoStatusEnum.CLOSED) {
      return 'danger';
    }
    if (status === IAccountStatusDtoStatusEnum.OPEN) {
      return 'success';
    }
    return 'warning';
  }, [status]);

  const text = useMemo(() => {
    if (status === IAccountStatusDtoStatusEnum.CLOSED) {
      return 'Closed';
    }
    if (status === IAccountStatusDtoStatusEnum.FROZEN) {
      return 'Frozen';
    }
    if (status === IAccountStatusDtoStatusEnum.OPEN) {
      return 'Active';
    }
    if (status === IAccountStatusDtoStatusEnum.PENDING) {
      return 'Pending';
    }
    if (status === IAccountStatusDtoStatusEnum.PENDING_CLOSED) {
      return 'Pending closed';
    }
    return '';
  }, [status]);

  return (
    <Box direction="row" align="center" {...rest}>
      {isWithIndicator && (
        <Box
          width="10px"
          height="10px"
          background={color}
          round="50%"
          margin={{ right: 'spacing4' }}
          data-testid="enrollments-account-history_status-indicator"
        />
      )}

      <Text
        size="small"
        weight={isWithIndicator ? 700 : 500}
        data-testid="enrollments-account-history_status-text"
      >
        {text}
      </Text>
    </Box>
  );
};

export default EnrollmentsAccountHistoryStatus;
